import { startOfToday } from 'date-fns';
import { EmptyStateFeedItem, FeedItemType } from '../types';

export const getEmptyStateItem = (): EmptyStateFeedItem => {
  return {
    type: FeedItemType.EMPTY_STATE,
    createdAt: startOfToday().toISOString(),
  };
};
